import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";

export default function PaywallTeaser({ assessment }) {
  const pathways = assessment?.ai_recommendation?.pathways || {};
  const pathwayCount = Object.values(pathways).filter((p) => p && p.role_title).length;
  const jobCount = (assessment?.ai_recommendation?.pathways
    ? Object.values(pathways).reduce((n, p) => n + (p?.next_steps?.length || 0), 0)
    : 0);
  const trainingCount = Object.values(pathways).filter((p) => p?.training_required).length;
  const supportCount = (assessment?.government_support_review?.programs || []).filter(
    (p) => p.status === "may_be_eligible"
  ).length;

  const stats = [
    { label: "Career pathways found", value: pathwayCount, testid: "teaser-stat-pathways" },
    { label: "Action steps in your plan", value: jobCount, testid: "teaser-stat-jobs" },
    { label: "Training options to consider", value: trainingCount, testid: "teaser-stat-training" },
    { label: "Support programs you may qualify for", value: supportCount, testid: "teaser-stat-support" },
  ];

  return (
    <section
      className="mt-10 rounded-3xl border border-slate-200 bg-gradient-to-br from-slate-900 to-slate-800 text-white p-8 lg:p-12 shadow-[0_20px_60px_rgb(0,0,0,0.10)]"
      data-testid="paywall-teaser"
    >
      <div className="flex items-start gap-4 mb-6">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/10">
          <Sparkles className="h-5 w-5" />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-sky-300 font-medium">{"Here's what we found"}</p>
          <h2 className="text-2xl lg:text-3xl font-medium tracking-tight">Your plan is ready — unlock it with a membership.</h2>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl bg-white/10 border border-white/10 p-5" data-testid={s.testid}>
            <p className="text-3xl font-medium text-white">{s.value}</p>
            <p className="mt-1 text-xs text-slate-300">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-7 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
        <p className="text-sm text-slate-300 max-w-xl">
          The full Career Report, ongoing job matching, and weekly action plan are part of the Career Transition Membership — AUD $50/month, 3-month minimum.
        </p>
        <Link
          to="/subscribe"
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-medium text-slate-900 shadow-md hover:-translate-y-0.5 transition-all"
          data-testid="paywall-cta"
        >
          <Lock className="h-4 w-4" />
          Unlock my full report
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
